import Zoom from '@mui/material/Zoom';
import useMediaQuery from '@mui/material/useMediaQuery';

export type ScreenPoint = {
    x: number;
    y: number;
};

export function centerOf(element: Element): ScreenPoint {
    let rect = element.getBoundingClientRect();
    return { x: rect.left + rect.width / 2, y: rect.top + rect.height / 2 };
}

export function useExpandFromPoint(point: ScreenPoint | null) {
    const prefersReducedMotion = useMediaQuery('(prefers-reduced-motion: reduce)');

    if (prefersReducedMotion || point === null) {
        return {};
    }
    return {
        TransitionComponent: Zoom,
        TransitionProps: { style: { transformOrigin: `${point.x}px ${point.y}px` } }
    };
}
